import { ChangeDetectionStrategy, Component, input } from '@angular/core';
import { MatInputModule } from '@angular/material/input';
import { MatFormFieldModule } from '@angular/material/form-field';
import { FormControl, FormsModule, ReactiveFormsModule } from '@angular/forms';

@Component({
  selector: 'app-text-area',
  imports: [FormsModule, ReactiveFormsModule, MatFormFieldModule, MatInputModule],
  templateUrl: './text-area.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class TextAreaComponent {
  control = input.required<FormControl<string | number | null>>();
  errorMsg = input<string>('');
  label = input.required<string>();
  placeholder = input<string>('Eingabe erforderlich');
}
